/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddPvdConfigRequest,
  DeletePvdConfigRequest,
  PvdConfigurationOnAzure,
  UpdatePvdConfigRequest,
} from '../models/index';
import {
    AddPvdConfigRequestFromJSON,
    AddPvdConfigRequestToJSON,
    DeletePvdConfigRequestFromJSON,
    DeletePvdConfigRequestToJSON,
    PvdConfigurationOnAzureFromJSON,
    PvdConfigurationOnAzureToJSON,
    UpdatePvdConfigRequestFromJSON,
    UpdatePvdConfigRequestToJSON,
} from '../models/index';

export interface ApiPvdConfigAddPvdConfigPostRequest {
    addPvdConfigRequest?: AddPvdConfigRequest;
}

export interface ApiPvdConfigDeletePvdConfigDeleteRequest {
    deletePvdConfigRequest?: DeletePvdConfigRequest;
}

export interface ApiPvdConfigGetAllByOrgCodeGetRequest {
    orgCode?: string;
}

export interface ApiPvdConfigGetByOrgCodeAndIdGetRequest {
    orgCode?: string;
    configId?: string;
}

export interface ApiPvdConfigUpdatePvdConfigPutRequest {
    updatePvdConfigRequest?: UpdatePvdConfigRequest;
}

/**
 * 
 */
export class PvdConfigApi extends runtime.BaseAPI {

    /**
     */
    async apiPvdConfigAddPvdConfigPostRaw(requestParameters: ApiPvdConfigAddPvdConfigPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PvdConfigurationOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PvdConfig/AddPvdConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddPvdConfigRequestToJSON(requestParameters['addPvdConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PvdConfigurationOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiPvdConfigAddPvdConfigPost(requestParameters: ApiPvdConfigAddPvdConfigPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PvdConfigurationOnAzure> {
        const response = await this.apiPvdConfigAddPvdConfigPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPvdConfigDeletePvdConfigDeleteRaw(requestParameters: ApiPvdConfigDeletePvdConfigDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PvdConfig/DeletePvdConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeletePvdConfigRequestToJSON(requestParameters['deletePvdConfigRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPvdConfigDeletePvdConfigDelete(requestParameters: ApiPvdConfigDeletePvdConfigDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPvdConfigDeletePvdConfigDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPvdConfigGetAllByOrgCodeGetRaw(requestParameters: ApiPvdConfigGetAllByOrgCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PvdConfigurationOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PvdConfig/GetAllByOrgCode`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PvdConfigurationOnAzureFromJSON));
    }

    /**
     */
    async apiPvdConfigGetAllByOrgCodeGet(requestParameters: ApiPvdConfigGetAllByOrgCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PvdConfigurationOnAzure>> {
        const response = await this.apiPvdConfigGetAllByOrgCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPvdConfigGetByOrgCodeAndIdGetRaw(requestParameters: ApiPvdConfigGetByOrgCodeAndIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PvdConfigurationOnAzure>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        if (requestParameters['configId'] != null) {
            queryParameters['config_id'] = requestParameters['configId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PvdConfig/GetByOrgCodeAndId`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PvdConfigurationOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiPvdConfigGetByOrgCodeAndIdGet(requestParameters: ApiPvdConfigGetByOrgCodeAndIdGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PvdConfigurationOnAzure> {
        const response = await this.apiPvdConfigGetByOrgCodeAndIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPvdConfigUpdatePvdConfigPutRaw(requestParameters: ApiPvdConfigUpdatePvdConfigPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PvdConfigurationOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PvdConfig/UpdatePvdConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePvdConfigRequestToJSON(requestParameters['updatePvdConfigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PvdConfigurationOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiPvdConfigUpdatePvdConfigPut(requestParameters: ApiPvdConfigUpdatePvdConfigPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PvdConfigurationOnAzure> {
        const response = await this.apiPvdConfigUpdatePvdConfigPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
